/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import ProgressionJudgement from '@linc-technologies/linced-common/enums/progression-judgement';
import ProgressionDescription from '@linc-technologies/linced-common/enums/progression-descriptions';

export default class AchievementKey extends Component {
  isExpanded = false;
  ProgressionJudgement = ProgressionJudgement;
  ProgressionDescription = ProgressionDescription;
}
